import { useMemo } from 'react';

import { CrossBorderPaymentState } from '../components/transaction/CrossBorderPayment/form/state';
import useCurrencies from '../fetchHooks/useCurrencies';
import type { Currency } from '../generated-types';

const useCurrency = (state: CrossBorderPaymentState): Currency | undefined => {
    const { data: currencies } = useCurrencies();

    return useMemo(() => {
        const countryCurrencyIsFoundInCurrencies = currencies?.find(
            (currency) => currency.currency === state.country?.currency,
        );
        if (state.currency) {
            return state.currency;
        }
        if (countryCurrencyIsFoundInCurrencies) {
            return state.country?.currency;
        }
        if (currencies) {
            return 'EUR';
        }
        return undefined;
    }, [currencies, state.country?.currency, state.currency]);
};

export default useCurrency;
